import { computed, type ComputedRef } from 'vue'
import { useTranslator } from '@/i18n'
import { CountryCode } from '@/graphql/api'
import type { SelectOption } from '@/components/ui/inputs/th-select.ts'

export function useCountries(): {
    countries: ComputedRef<SelectOption<CountryCode>[]>
} {
    const { getCountryName } = useTranslator()

    const countries = computed(() =>
        Object.values(CountryCode).map((code): SelectOption<CountryCode> => {
            return {
                label: String(getCountryName(code)),
                value: code,
            }
        })
    )

    return {
        countries,
    }
}
